<template>
  <div>
    <Select v-model="uid" filterable remote :remote-method="getUsers" :loading="loading"
    :label="name" @on-change="auth">
      <Option v-for="(user, key) in users" :value="key" :key="key" :label="user">
        <span>{{ user }}</span>
      </Option>
    </Select>
    <Card>
      <p slot="title">已授权研究管理者</p>
      <Tag type="dot" v-for="(admin, key) in admins" :key="key"
       @on-close="delAuth" closable color="primary" :name="admin.id">
        <Avatar size="small" style="color: #FFFFFF;background-color: #05a294">
          {{ admin.user.name[0] }}
        </Avatar>
        {{ admin.user.name }} ( {{ admin.user.email }} )
      </Tag>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'auth-admin',
  data: function () {
    return {
      loading: false,
      uid: '',
      name: '',
      users: [],
      admins: []
    }
  },
  props: ['meta'],
  methods: {
    init: function (id) {
      this.axios.get('/study-team/list-admins?id=' + id)
        .then((response) => {
          this.admins = response.data
        })
    },
    fetchData: function (query) {
      this.axios.get('/study-team/list-users', { params: { query: query } })
        .then((response) => {
          this.users = response.data
        })
    },
    getUsers: function (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.fetchData(query)
        }, 200)
      } else {
        this.users = []
      }
    },
    auth: function () {
      this.axios.post('/study-team/auth-admin?id=' + this.meta, { uid: this.uid })
        .then((response) => {
          this.init(this.meta)
          this.uid = null
        })
    },
    delAuth: function (event, name) {
      this.axios.delete('/study-team/delete?id=' + name)
        .then((response) => {
          this.init(this.meta)
        })
    }
  }
}
</script>
